module.exports = __webpack_public_path__ + "img/FastPaceTransfer_Logo_Resized.8461262a.png";